const hasUpperlowerCase = val =>
   /^[a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*[a-zA-Z][a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*$/.test(val);
const hasNumberPhone = val => /^[\d()+-]{10,21}$/.test(val);
const hasEmail = val =>
   /^(?!-)(?!.*--)[A-Za-z0-9!#$%&‘*+=?^_`{|}~.-]+(?<!-)(?<!-)@(?!-)(?!.*--)[A-Za-z0-9.-]+(?<!-)(?<!-)$/.test(val);
const hasPassword = val => /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9!@#$%^&*()\-_=+\\|;:'",.<>/?]*$/.test(val); //eslint-disable-line

export { hasNumberPhone, hasPassword, hasUpperlowerCase, hasEmail };
